import classNames from 'classnames';
import { memo } from 'react';

import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';

const rootCss = ({ palette, spacing, transitions }) => ({
  padding: '4px 6px',
  transition: transitions.create(['background-color', 'color']),
  minWidth: spacing(3),
  height: 24,
  margin: '4px 1px',
  '&:first-child': { marginLeft: 2 },
  '&:last-child': { marginRight: 2 },
  '& svg': { margin: 0 },

  '&.root_active': {
    backgroundColor: palette.primary.background,
    color: palette.primary.main,
  },
});

function ToolbarButton({ active, buttonRef, children, disabled, onToggle, toggleKey, tooltip, ...rest }) {
  function handleMouseDown(e) {
    e.preventDefault();
    onToggle(toggleKey, e);
  }

  const btn = (
    <Button
      className={classNames({ root_active: active })}
      color="inherit"
      css={rootCss}
      disabled={disabled}
      onMouseDown={onToggle && handleMouseDown}
      ref={buttonRef}
      {...rest}
    >
      {children}
    </Button>
  );

  if (tooltip && !disabled) {
    return (
      <Tooltip enterDelay={300} placement="top" title={tooltip}>
        {btn}
      </Tooltip>
    );
  }
  return btn;
}

export default memo(ToolbarButton);
